(() => {
  'use-strict';

  const defaultOptions = {
    mediaQuery: 'min',
    perPage: 1,
    pagination: false,
    arrows: true,
    autoplay: false,
    slideFocus: false,
    gap: '1.25rem',
  };

  const twoColsOptions = {
    perPage: 1,
    breakpoints: {},
  };

  twoColsOptions.breakpoints[window.breakpointsDefinition.desktop] = {
    perPage: 2,
  };

  const threeColsOptions = {
    perPage: 1,
    breakpoints: {},
  };

  threeColsOptions.breakpoints[window.breakpointsDefinition.tablet] = {
    perPage: 2,
  };
  threeColsOptions.breakpoints[window.breakpointsDefinition.desktop] = {
    perPage: 3,
  };

  const fourColsOptions = {
    perPage: 1,
    breakpoints: {},
  };

  fourColsOptions.breakpoints[window.breakpointsDefinition.tablet] = {
    perPage: 2,
  };
  fourColsOptions.breakpoints[window.breakpointsDefinition.desktop] = {
    perPage: 3,
  };
  fourColsOptions.breakpoints[window.breakpointsDefinition['desktop-large']] = {
    perPage: 4,
  };

  function init(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('initCarousel' in element.dataset) {
        return;
      }
      element.dataset.initCarousel = true;

      let jsScript = document.getElementById('splide-js');
      let cssLink = document.getElementById('splide-css');
      const jsScriptUrl = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@3.6.12/dist/js/splide.min.js';
      const cssScriptUrl = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@3.6.12/dist/css/splide.min.css';

      const initSlider = () => {
        // eslint-disable-next-line prefer-object-spread
        const options = Object.assign({}, defaultOptions);

        if (element.classList.contains('-twoCols')) {
          // eslint-disable-next-line prefer-object-spread
          Object.assign(options, twoColsOptions);
        }

        if (element.classList.contains('-threeCols')) {
          // eslint-disable-next-line prefer-object-spread
          Object.assign(options, threeColsOptions);
        }

        if (element.classList.contains('-fourCols')) {
          // eslint-disable-next-line prefer-object-spread
          Object.assign(options, fourColsOptions);
        }

        // eslint-disable-next-line no-undef
        const splide = new Splide(element, options);
        splide.mount();

        document.addEventListener('breakpointChange', () => {
          setTimeout(() => {
            const hasNoHoverflow = splide.length <= splide.options.perPage;
            element.classList.toggle('-hasNoHoverflow', hasNoHoverflow);
          }, 50);
        });
      };

      const pJs = new Promise((resolve, reject) => {
        if (jsScript === null) {
          jsScript = document.createElement('script');
          jsScript.type = 'text/javascript';
          jsScript.src = jsScriptUrl;
          jsScript.id = 'splide-js';
          document.head.appendChild(jsScript);
        }

        jsScript.addEventListener('load', () => {
          // the JS has been loaded into the script tag
          resolve(jsScript);
        });
        jsScript.addEventListener('error', (err) => {
          // there was an error
          // eslint-disable-next-line no-console
          console.warn('your js is ready, NOT.');
          reject(err);
        });
      });

      const pCss = new Promise((resolve, reject) => {
        if (cssLink === null) {
          cssLink = document.createElement('link');
          cssLink.setAttribute('rel', 'stylesheet');
          cssLink.setAttribute('type', 'text/css');
          cssLink.id = 'splide-css';
          cssLink.href = cssScriptUrl;
          document.head.appendChild(cssLink);
        }
        cssLink.addEventListener('load', () => {
          // the CSS has been loaded into the style tag
          resolve(cssLink);
        });
        cssLink.addEventListener('error', (err) => {
          // there was an error
          // eslint-disable-next-line no-console
          console.warn('your css is ready, NOT.');
          reject(err);
        });
      });

      Promise.all([pJs, pCss])
        .then(() => {
          initSlider();
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          console.warn('SOMETHING BAD HAPPENED');
        });
    });
  }

  Drupal.behaviors.carousel = {
    attach: () => {
      const elements = document.querySelectorAll('.js-carousel');
      if (elements.length !== 0) {
        init(elements);
      }
    },
  };
  // eslint-disable-next-line no-undef
})();
